import Url from 'environment';
import Api from '../../api';

class AuthService extends Api {
  constructor(props) {
    super(props);
  }

  /**
   * @description 로그인
   * @returns
   */
  async register(email, password) {
    if (!email || !password) {
      return;
    }

    const form = new FormData();
    form.append('email', email);
    form.append('password', password);

    const res = await this.commonAjax('post', Url.named, `users`, form, {}, false);

    return res;
  }

  /**
   * @description 로그인
   * @returns
   */
  async login(email, password, recaptcha) {
    if (!email || !password) {
      return;
    }

    const form = new FormData();
    form.append('email', email);
    form.append('password', password);
    form.append('recaptcha', recaptcha);

    const res = await this.commonAjax('post', Url.named, `login`, form, {}, false);

    return res;
  }

  /**
   * @description 아이디 찾기
   * @returns
   */
  async idFind(certifyToken) {
    if (!certifyToken) {
      return;
    }

    const res = await this.commonAjax('get', Url.named, `certify-tokens/${certifyToken}/email`);

    return res;
  }
  
  /**
   * @description 비밀번호 재설정
   * @returns
   */
  async passwordChange(certify_token, email, password) {
    if (!certify_token || !email || !password) {
      return;
    }

    const form = new URLSearchParams();
    form.append('email', email);
    form.append('password', password);

    const res = await this.commonAjax('put', Url.named, `certify-tokens/${certify_token}/password`, form);

    return res;
  }
  
  /**
   * @description 휴면계정 해제
   * @returns
   */
  async dormancyRelease(certify_token) {
    if (!certify_token) {
      return;
    }

    const res = await this.commonAjax('put', Url.named, `certify-tokens/${certify_token}/active`);

    return res;
  }
}

export default new AuthService();
